import React from 'react';
import cn from 'classnames';

import panelStyles from './panel.scss';

interface IProps {
  title: string,
  subTitles?: string[],
  children: React.ReactNode,
  classNameWrapper: string,
  classNameTitle?: string,
  classNameSubTitle?: string,
  classNameContent?: string
}

const Panel = (props: IProps) => {
  const {
    title,
    subTitles = [],
    children,
    classNameWrapper,
    classNameTitle,
    classNameSubTitle,
    classNameContent
  } = props;

  return (
    <div className={ cn(panelStyles.wrapper, classNameWrapper) }>
      <div className={ cn(panelStyles.header, classNameTitle) }>
        { title }
      </div>
      { subTitles.map((subTitle, index) => (
        <div
          /* eslint-disable-next-line react/no-array-index-key */
          key={ index }
          className={ cn(panelStyles.subTitle, classNameSubTitle) }
        >
          { subTitle }
        </div>
      ))}
      <div className={ classNameContent }>
        { children }
      </div>
    </div>
  );
};

export default Panel;
